import * as XLSX                        from 'xlsx/xlsx.mjs';
import JSZip                            from 'jszip';

import { TAB_PCB_PARTS } from 'product_tabs/tabs/data/tabType';
import { initializeBom } from './initialize_bom';

import { 
  excelFileExtensions,
  zipFileTypes,
  isValidBomFile,  
  isTemporalDirectory,
} from "../data/BomFileTypes";

import { 
  changeBomFile,
  clearMessages,
  updateFileDirectory,
  updateShowBomSelection,
  updateUploadZipFile,
  updateAvailableBomInZip,
  updateChangedZipFile,
  openModal,
} from '../bomSlice';

import { 
  selectDataForBomReadFile,
  selectDataForZipProcessFileForParts,
} from '../selector/selectors';

export const processFile = (file) => async (dispatch, getState) => {
  const {
    bom_saved,
  } = selectDataForZipProcessFileForParts(getState());
  
  dispatch(updateFileDirectory({}))
  if(!file) {
    dispatch(updateUploadZipFile(false))
    dispatch(updateAvailableBomInZip(false))
    return;
  }

  dispatch(updateUploadZipFile(true))
  if(bom_saved) dispatch(updateChangedZipFile(true))
  if(!zipFileTypes.includes(file.type)){
    dispatch(updateAvailableBomInZip(false))
    return;
  }

  JSZip.loadAsync(file).then((zip) => {
    const inner_files = zip.filter((relativePath, zipEntry) => !zipEntry.dir && !isTemporalDirectory(zipEntry.name)).map((zipEntry) => zipEntry.name)
    const inner_bom_files = zip.filter((relativePath, zipEntry) => !zipEntry.dir && isValidBomFile(zipEntry.name)).map((zipEntry) => zipEntry.name)
    if(inner_bom_files.length == 0) {
      dispatch(updateAvailableBomInZip(false))
      return;
    }
    dispatch(updateAvailableBomInZip(true))
    dispatch(updateFileDirectory({
      data: file.name,
      children: inner_files,
    }))
    dispatch(updateShowBomSelection(true))
  }).catch((error) => {})
}

export const openBomFile = (bom_file) => async (dispatch, getState) => {
  const {
    activeTab,
    zip_file_input_id,
  } = selectDataForBomReadFile(getState());

  const zipFile = $(`#${zip_file_input_id}`).prop("files")[0]
  if(!zipFile || !excelFileExtensions.includes(bom_file.split('.').pop())) return;

  JSZip.loadAsync(zipFile).then((zip) => {
    zip.file(bom_file).async("arraybuffer").then((arrayBuffer) => {
      dispatch(onReadExcelFile(arrayBuffer, bom_file, activeTab));
    }).catch((error) => {
      dispatch(updateShowBomSelection(false));
    })
  }).catch((error) => {
    dispatch(updateShowBomSelection(false));
  })
}

const onReadExcelFile = (array_buffer, file_name, active_tab) => async (dispatch, getState) => {
  dispatch(clearMessages())
  dispatch(changeBomFile(null))
  const excel_data = XLSX.read(array_buffer)
  const first_sheet = excel_data.Sheets[excel_data.SheetNames[0]]
  const rows = XLSX.utils.sheet_to_json(first_sheet, {header: 1, defval: ""})
  const max_length = Math.max(...rows.map(row => row.length))
  const workbook = rows.map(row => row.concat(Array(max_length - row.length).fill("")))
  const bom_header = Array(max_length).fill("")
  dispatch(initializeBom(bom_header, workbook, file_name))
  dispatch(updateShowBomSelection(false));
  if(active_tab === TAB_PCB_PARTS) dispatch(openModal())
}